import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import useAutoLogin from "./utils/useAutoLogin";

// Layout
import Layout from "./components/layout/Layout";

// Pages
import Checklists from "./pages/Checklists";
import ChecklistCreate from "./pages/ChecklistCreate";
import ChecklistView from "./pages/ChecklistView";
import Templates from "./pages/Templates";
import TemplateCreate from "./pages/TemplateCreate";
import TemplateView from "./pages/TemplateView";
import NotFound from "./pages/NotFound";
import TechnicianChecklistView from "./pages/TechnicianChecklistView";

function App() {
  // useAutoLogin();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Templates />} />
            <Route path="/checklists" element={<Checklists />} />
            <Route path="/checklists/new" element={<ChecklistCreate />} />
            <Route path="/checklists/:id" element={<ChecklistView />} />
            <Route path="/checklist" element={<TechnicianChecklistView />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/templates/new" element={<TemplateCreate />} />
            <Route path="/templates/:id" element={<TemplateView />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
